import styled from 'styled-components'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Text } from '../../../components/Text/Text'
import { midGray } from '../../../theme/colors'
import { ScoreIndicator } from './SafetyInfoTooltip'

interface SafetyScoreHeaderItemProps {
  title: string
  color?: string | null
  label?: string | null
  score?: number | null
  isPercentage?: boolean
}

export function SafetyScoreHeaderItem({
  title,
  color,
  label,
  score,
  isPercentage,
}: SafetyScoreHeaderItemProps) {
  return (
    <SafetyScoreHeaderItemWrapper flex={1}>
      <Text variant="header4" fontColor={midGray} style={{ whiteSpace: 'nowrap' }}>
        {title}
      </Text>
      <HeaderItemScore>
        <ScoreIndicator $backgroundColor={color} />
        <Text variant="header4" style={{ whiteSpace: 'nowrap' }}>
          {label}
        </Text>
        <Text variant="header4">
          {score?.toFixed(0)}
          {isPercentage ? '%' : ''}
        </Text>
      </HeaderItemScore>
    </SafetyScoreHeaderItemWrapper>
  )
}

export const SafetyScoreHeaderItemWrapper = styled(FlexBox)`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr;
`

const HeaderItemScore = styled(FlexBox)`
  display: grid;
  gap: 12px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`
